import React, { Component } from 'react'
import { connect } from 'react-redux';
import { HeroMap, Hero, Description, Methods, Footer } from './components';
import { windowResize } from './actions';


const Fragment = React.Fragment;

class App extends Component {
  constructor(props){
    super(props);

    this.handleResize = this.handleResize.bind(this);
  }
  
  componentDidMount(){

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }


  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize(e){
    console.log(window.innerHeight, "window.innerheight");
    this.props.dispatch(windowResize(window.innerWidth, window.innerHeight));
  }

  render() {
    return (
      <Fragment>
        <Hero />
        <Methods />
        <HeroMap />
        <Description />
        <Footer />
      </Fragment>
    )
  }
}

let mapStateToProps = state => {
  return {

  }
}

export default connect(mapStateToProps)(App);